export const ProtocolTypes = {
  QUESTION: 'QUESTION',
  SCRIPT: 'SCRIPT',
  CATEGORY: 'CATEGORY',
  SUB_CATEGORY: 'SUB_CATEGORY',
  ACTION: 'ACTION',
  BUS: 'BUS'
}
